import React, {useCallback, useState} from "react";
import styles from "../../assets/scss/v1/WeddingTimeLine.module.scss"
import flower1 from "../../assets/images/v1/wedding-timeline/flower1.png"
import image1 from "../../assets/images/DSC02672.JPG";
import image2 from "../../assets/images/DSC02430.JPG";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGift, faMapMarkerAlt, faPhone} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../components/Modal";
import flowbg1 from "../../assets/images/v1/wedding-card/flowerRight1.png"
import useWindowSize from "../../hooks/useWindowSize";



const WeddingTimeLine = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkGift, setLinkGift] = useState("");

    const windowSize = useWindowSize();

    const husband = {
        phone: '0972006318',
        zalo: 'https://zalo.me/0972006318',
        linkGift: 'https://img.vietqr.io/image/tpbank-04501649201-print.jpg?addInfo=Chuc%20mung%20hanh%20phuc&accountName=Bach%20Van%20Hai',
        mapUrl: 'https://maps.app.goo.gl/VY6YE5ebe5tfWXBB8'
    }

    const wife = {
        phone: '0869820891',
        zalo: 'https://zalo.me/0869820891',
        linkGift: 'https://img.vietqr.io/image/Vietcombank-0851000039008-print.jpg?addInfo=Chuc%20mung%20hanh%20phuc&accountName=Vu%20Minh%20Giang',
        mapUrl: 'https://maps.app.goo.gl/TVxLtmBJRAMxX6u67'
    }

    const renderPhoneButton = useCallback((info) => {
        if (windowSize.width > 768) {
            return (
                <a href={info.zalo} target="_blank" rel="noopener noreferrer" className={styles.actionButton}>
                    <FontAwesomeIcon icon={faPhone} />
                </a>
            );
        } else {
            return (
                <a href={`tel:${info.phone}`} className={styles.actionButton}>
                    <FontAwesomeIcon icon={faPhone} />
                </a>
            );
        }
    }, [windowSize.width]);

    const renderMapButton = useCallback((info) => {
        return (
            <a href={info.mapUrl} target="_blank" rel="noopener noreferrer" className={styles.actionButton}>
                <FontAwesomeIcon icon={faMapMarkerAlt} />
            </a>
        );
    }, []);

    const handleGiftClick = useCallback((isWife) => {
        const newLinkGift = isWife ? wife.linkGift : husband.linkGift;
        setLinkGift(newLinkGift);
        setIsModalOpen(true);
    }, []);

    const renderGiftButton = useCallback((isWife) => {
        return (
            <button className={styles.actionButton} onClick={() => handleGiftClick(isWife)}>
                <FontAwesomeIcon icon={faGift} />
            </button>
        )
    }, [handleGiftClick]);

    return (
        <>
            <div className={styles.WeddingTimeLine}>
                <div className={styles.container}>
                    <div className={styles.banner}>
                        <div className={styles.weddingTextSection}>
                            <div className={styles.weddingText}>
                                <span className={styles.wedding}>GIỚI THIỆU</span>
                                <img
                                    src={flower1}
                                    alt="flower1"
                                />
                            </div>
                            {/*<div className={styles.timeline}>timeline</div>*/}
                        </div>
                        <div className={styles.images}>
                            <div className={styles.image}>
                                <img className={`${styles.imageBanner}`} src={image2} alt="image"/>
                                <div className={styles.actions}>
                                    {renderPhoneButton(wife)}
                                    {renderGiftButton(true)}
                                    {renderMapButton(wife)}
                                </div>
                            </div>
                            <div className={styles.image1}>
                                <img className={`${styles.image12} ${styles.imageBanner}`} src={image1} alt="image1"/>
                                {/*<img className={styles.imagebg} src={flowbg1} alt="flowbg1"/>*/}
                                <div className={styles.actions}>
                                    {renderPhoneButton(husband)}
                                    {renderGiftButton(false)}
                                    {renderMapButton(husband)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                        zIndex: 9999
                    },
                    content: {
                        position: 'absolute',
                        width: '70%',
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        transform: 'translate(-50%, -50%)',
                        maxHeight: '80vh',
                        overflow: 'auto'
                    }
                }}
            >
                <img src={linkGift} alt="Gift" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
            </Modal>
        </>
    )
}

export default WeddingTimeLine;